import { Flex, Tag } from 'antd';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const RecordsTagsSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeRecordsTags } = useNewClientsListContext();

  const { recordsTags, isIncludeRecordsTags } = filtersMap.get(id)!;

  if (recordsTags.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {recordsTags.length > 0 && (
        <Tag
          key={isIncludeRecordsTags ? 'include' : 'exclude'}
          className={`${PF}__tag`}
          closable
          onClose={() => onChangeRecordsTags([], id)}
        >
          {isIncludeRecordsTags ? 'Включено' : 'Исключено'}:{' '}
          {recordsTags.length} тег
          {recordsTags.length === 2 ||
          recordsTags.length === 3 ||
          recordsTags.length === 4
            ? 'а'
            : recordsTags.length > 4
            ? 'ов'
            : ''}
        </Tag>
      )}
    </Flex>
  );
};
